import { createApi } from "@reduxjs/toolkit/query/react";
import { unauthenticatedApiBaseQuery } from "../helpers";

const callTranslatorApi = createApi({
  reducerPath: "callTranslator",
  tagTypes: [],
  baseQuery: unauthenticatedApiBaseQuery("/calltranslator"),
  endpoints: builder => ({
    getCallTranslatorHubUrl: builder.query<string, string>({
      query: conversationId => `/conversations/${conversationId}/location`,
      transformResponse: (response: { hubUrl: string }) => response.hubUrl,
    }),
  }),
});

export const {
  useGetCallTranslatorHubUrlQuery,
  useLazyGetCallTranslatorHubUrlQuery,
} = callTranslatorApi;

export default callTranslatorApi;
